import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgGroupListModule } from '@app/src/app/groups/containers/MgGroupList';
import { MgIconModule } from '@app/src/app/icon';
import { MgOverlayToolsModule } from '@app/src/app/overlay/tools';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { RevHeroService } from '@app/src/app/services/RevHero';
import { FormModule } from '@app/src/app/shared/components/form';
import { PlaceholderModule } from '@app/src/app/shared/components/placeholder';
import { ScheduleWidgetModule } from '@app/src/app/shared/components/student-schedule-widget/student-schedule-widget.module';
import { CommonUIModules } from '@app/src/app/shared/modules';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { SharedToolsModule } from '@modules/tools/shared-tools/shared-tools.module';

import { GenericButtonModule } from '@shared/components/button';
import { GenericModule } from '@shared/components/generic';
import { OverlayModule, ModalOverlayService } from '@shared/components/modal-overlay';
import { RedeemPointsModalModule } from '@shared/components/redeem-points-modal';
import { TextModule } from '@shared/components/text/text.module';
import { TilesCarouselModule } from '@shared/components/tiles-carousel';
import { UserProfileHeaderModule } from '@shared/components/user-profile-header';

import { TtMyClassModule } from './components/tt-my-class/tt-my-class.module';
import { TtMyToolsComponent } from './components/tt-my-tools/tt-my-tools.component';
import { TtRootComponent } from './components/tt-root/tt-root.component';
import { TeacherToolsService } from './services';
import { TeacherToolsFlexTimeService } from './services/tt-flex-time.service';

@NgModule({
  imports: [
    // Minga dependencies
    MgIconModule,
    MgOverlayToolsModule,
    MgSpinnerModule,
    MgGroupListModule,
    PermissionsModule,
    OverlayModule,
    GenericButtonModule,
    TilesCarouselModule,
    MgPipesModule,
    SharedToolsModule,
    TextModule,
    MgEmptyStateModule,
    RouterModule,
    RedeemPointsModalModule,
    NgSelectModule,
    TtMyClassModule,
    GenericModule,
    UserProfileHeaderModule,
    CommonModule,
    CommonUIModules,
    SharedToolsModule,
    FormModule,
    PlaceholderModule,
    ScheduleWidgetModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    MatRippleModule,
    MatMenuModule,
  ],
  declarations: [TtRootComponent, TtMyToolsComponent],
  exports: [TtRootComponent, TtMyToolsComponent],
  providers: [TeacherToolsService, ModalOverlayService, TeacherToolsFlexTimeService, RevHeroService],
})
export class TeacherToolsModule {}
